import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import ServiceInclude from "../../component/ServiceInclude";
import { Helmet } from "react-helmet";


const Implement = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <Helmet prioritizeSeoTags={true}>
                <meta http-equiv="content-type" content="text/html; charset=utf-8" />
                <meta name="format-detection" content="telephone=no" />
                <title>Top Salesforce Implementation Partner</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <meta name="description"
                    content=""
                />
                <meta
                    name="keywords"
                    content=""
                />
            </Helmet>

            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Implementation Services</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/implementation/implementation.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service bottom">
                            <p className="prose-lg wow fadeUp">
                                <strong>Salesforce implementation services </strong>We offer comprehensive Salesforce services, including consulting, configuration, customization, migration, integration, support, and more. With expertise in CRM development since 2014, Codezix assists businesses in implementing robust Salesforce solutions to optimize their sales, customer service, and marketing operations.
                            </p>
                        </div>

                        <div className="sasesforce-benifit">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Implementation Benefits</h2>
                            </div>
                            <div className="row mt-4">
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>30% </h3>
                                        <p className="wow fadeUp prose-lg">increase in lead conversion</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>28% </h3>
                                        <p className="wow fadeUp prose-lg">increase in sales revenue</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="benifit-number">
                                        <h3>45% </h3>
                                        <p className="wow fadeUp prose-lg">increase in customer retention</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4 bottom">
                            <div className="valuation-box">
                                <div className="col-md-9">
                                    <h3>Achieve Success with Your Salesforce Implementation</h3>
                                    <p className="prose-lg wow fadeUp">Codezix’s expert consultants understand how to harness the power of Salesforce to enhance your customer acquisition, conversion, and retention strategies.</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="button_exp mt-5">
                                        <Link to="/contact"><button>CONTACT US</button> </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="salesforce-product ">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Products We Implement</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix’s Salesforce team is ready to support you in implementing:</p>
                            </div>
                            <div class="row mt-5">
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/sales-cloud">
                                            <h3 class="mt-0">Sales Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/service-cloud">
                                            <h3 class="mt-0">Service Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/marketing-cloud">
                                            <h3 class="mt-0">Marketing Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/community-cloud">
                                            <h3 class="mt-0">Community Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/finencial-service-cloud">
                                            <h3 class="mt-0">Financial Services Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/non-profit">
                                            <h3 class="mt-0">Nonprofit Cloud</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/salesforce/cpq">
                                            <h3 class="mt-0">Salesforce CPQ</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="software-develop salesf-box height-100">
                                        <Link to="/customization#">
                                            <h3 class="mt-0">Salesforce Chatter</h3>
                                            <i class="fa fa-long-arrow-right arrow-icon" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix">
                            <div className='explore-heading text-left'>
                                <h2>Why Choose Codezix</h2>
                            </div>
                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg">Codezix is proud to be recognized as a 3-Year Champion in The Americas’ Fastest-Growing Companies Rating by the Financial Times.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in IT business.</li>
                                    <li className="wow fadeUp prose-lg">10+ years in CRM services.</li>
                                    <li className="wow fadeUp prose-lg">200+ professionals on board.</li>
                                    <li className="wow fadeUp prose-lg">Expertise across industries such as manufacturing, retail, professional services, healthcare, banking, telecommunications, and more.</li>
                                </ul>
                            </div>
                            <div className='client-section'>
                                <div className='row top'>
                                    <Swiper
                                        breakpoints={{
                                            425: {
                                                slidesPerView: 2,
                                                spaceBetween: 10,
                                            },
                                            640: {
                                                slidesPerView: 3,
                                                spaceBetween: 10,
                                            },
                                            768: {
                                                slidesPerView: 4,
                                                spaceBetween: 30,
                                            },
                                            1024: {
                                                slidesPerView: 5,
                                                spaceBetween: 30,
                                            },
                                        }}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        modules={[Pagination, Autoplay]}
                                        className="testimonialSwiper-client"
                                    >
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/partner-5.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-1.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-2.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-3.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                        <SwiperSlide className="col-md-4 col-4">
                                            <div className='client-image-slide-partnerships'>
                                                <img src={require('../../assets/images/partner/sales-4.webp')} alt='' />
                                            </div>
                                        </SwiperSlide>
                                    </Swiper>
                                </div>
                            </div>
                        </div>

                        <div className='achieve-project mb-4'>
                            <button className="prose-md">What makes Codezix different</button>
                            <h3>We ensure project success, no matter the circumstances</h3>
                            <p>Codezix does not pass mere project administration off as project management, which, unfortunately, is a common practice in the market. We practice real project management, ensuring project success for our clients no matter what.</p>
                            <Link to="/"> <button>See how we do it&nbsp;<i class="fa fa-arrow-right" aria-hidden="true"></i></button></Link>
                        </div>

                        <div className="salesforc-services">
                            <div className='explore-heading text-left'>
                                <h2>Salesforce Implementation Stages </h2>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <Link to="/consulting"><h3>Salesforce consulting</h3></Link>
                                        <p className="wow fadeUp prose-lg">At this stage, we carefully analyze your current business needs and identify the key objectives Salesforce should address, such as boosting sales team productivity, shortening
                                            lengthy sales cycles, or building a unified customer view. Next, we outline strategies to achieve your goals using Salesforce's capabilities, while considering any necessary customizations
                                            and integrations to ensure the solution aligns perfectly with your requirements. Additionally, we meticulously plan the implementation process to ensure each step is completed on time and within budget.</p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/consulting.png')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <Link to="/consulting"><h3>Customization and configuration</h3></Link>
                                        <p className="wow fadeUp prose-lg">
                                            We offer two approaches to tailoring your Salesforce solution, each varying in complexity, cost, and degree of platform modification. Configuration involves adjusting Salesforce’s default features using point-and-click tools. In contrast, customization is a development-focused process that enables more extensive modifications through Apex code, ideal for implementing large-scale changes to better align with your business goals.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/analyse.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <Link to="/consulting"><h3>Integration</h3></Link>
                                        <p className="wow fadeUp prose-lg">
                                            We handle integrations to ensure your Salesforce solution works seamlessly with third-party systems like ERP, e-commerce platforms, and document management systems, providing enhanced visibility of data flows across all integrated applications.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/integration.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Data transfer from old CRM</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We ensure a smooth data migration into your new Salesforce solution, with no data loss, corruption, or system downtime, minimizing any impact on your business processes. By analyzing and structuring your legacy data before migration, we ensure it remains well-organized and ready to use immediately. To maintain data quality post-migration, we also implement data structuring rules, such as duplicate prevention protocols.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/CRM.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>User training</h3>
                                        <p className="wow fadeUp prose-lg">
                                            We offer Salesforce training to boost user adoption, helping users fully embrace the capabilities of your tailored Salesforce solution. Our training ensures users can make the most of both default and custom features, ultimately enhancing productivity across your team.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/training.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Launch</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Once we develop a custom Salesforce-based solution in the development environment and have it thoroughly tested by QA engineers, we migrate it to the UAT (User Acceptance Testing) environment. Here, the customer's representatives can test the solution’s functionality and ensure it meets their requirements. If the customer approves, Codezix experts deploy the solution to the production environment, making it fully accessible to the customer's employees.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/launch.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <Link to="/"><h3>After-launch support</h3></Link>
                                        <p className="wow fadeUp prose-lg">
                                            We offer on-demand after-launch support services during the initial phase of Salesforce usage (e.g., the first 3 months after launch). These services include fine-tuning features, enhancing user adoption, and resolving any Salesforce-related issues, along with providing release notes and additional user training as needed.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/implementation/support.webp')} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Evolution and Continuous Support</h2>
                                <p className="wow fadeUp prose-lg text-left">Continuous support services involve ongoing tuning of Salesforce features and processes to align with your evolving organizational needs. Additionally, these services include the development of custom apps to address any new business requirements that arise after implementation.</p>
                            </div>
                        </div>

                        <div className="salesforce-product bottom">
                            <div className='explore-heading text-left'>
                                <h2>Benefits of Salesforce Implementation by Codezix</h2>
                                <p className="wow fadeUp prose-lg text-left">With our assistance in Salesforce implementation, businesses across various industries can:</p>
                            </div>

                            <div className="why-listing mt-4">
                                <ul>
                                    <li className="wow fadeUp prose-lg"><strong>Achieve seamless and consistent automation of business processes. </strong>We automate a range of sales and customer service processes, including offering discounts, following up with prospects, and prioritizing cases. Depending on your business requirements, we can leverage Salesforce's default process automation tools or implement custom code-based solutions for more complex processes. This enables you to efficiently manage multiple sales territories, products, and services, ultimately improving customer satisfaction.</li>
                                    <li className="wow fadeUp prose-lg"><strong>Create a Salesforce solution that is user-friendly and convenient for end users.</strong> We specialize in delivering a seamless user experience that makes working with a Salesforce solution intuitive and efficient for sales managers, salespeople, customer service managers, and agents.</li>
                                    <li className="wow fadeUp prose-lg"><strong>Leverage a structured approach to solution delivery for more efficient and reliable results. </strong> We follow a phased approach to solution delivery, ensuring the solution aligns with your requirements while keeping project costs under control. For large-scale implementations, we deliver core functionality first and roll out additional features later, allowing customers to start using the solution quickly and address their primary needs right away. Alternatively, we can opt for a one-time delivery if that better suits your business needs.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="contact-shadow">
                            <div className="row mb-4">
                                <div className="valuation-box">
                                    <div className="col-md-9">
                                        <h3>Get Your Salesforce Running</h3>
                                        <p className="prose-lg wow fadeUp">If you're looking to enhance your sales, service, or marketing efforts, Salesforce implementation is the perfect solution. Our team will deliver a reliable Salesforce solution that is fully aligned with your business needs.</p>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="button_exp mt-5">
                                            <Link to="/contact"><button> Turn to our experts </button> </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Implement;